import { PersonaType } from '@vendasta/iam';

export const MILESTONE_IN_PROGRESS = 'In Progress';
export const MILESTONE_COMPLETED = 'Completed';
export const MILESTONE_WAITING_ON_CUSTOMER = 'Waiting on Customer';
export const MILESTONE_APPROVED_TAG = 'Approved';
export const MILESTONE_FEEDBACK_TAG = 'Revisions requested';
export const PRODUCT_ID_METADATA_KEY = 'ProductId';
export const ORDER_ID_METADATA_KEY = 'OrderId';
export const FULFILLMENT_ORDER_ID_METADATA_KEY = 'fulfillment_order_id';
export const PROJECT_TYPE = 'Project';
export const VISIBLE_TAG = 'BCVisible';
export const DEPENDENT_TAG = 'Dependent';
export const TASK_DATA_FEEDBACK_KEY = 'EnableSmbFeedback';
export const MAX_COMMENT_LENGTH = 2000;

// feature flag list used to fetch all features flags on project tracker
export const FEATURE_FLAG_LIST = [];

export const PROJECTS_ICON_GREEN = '#3C9A63';
export const DEFAULT_PAGE_SIZE = 4;
export const ACCESS = [PersonaType.digital_agent]; //It wasnt export before

// FulfillingPartnerId metadata key
export const FULFILLING_PARTNER_ID = 'FulfillingPartnerId'; //It wasnt export before

// partner metadata key
export const PARTNER = 'partner';

// account-group metadata key
export const ACCOUNT_GROUP = 'account-group';

// task Types
export const GENERIC = 'Generic';
export const CLIENT_REVIEW = 'ClientReview';
export const SCHEDULE_SOCIAL_POSTS = 'ScheduleSocialPosts';

export const ONBOARDING = 'Onboarding';
export const REVIEW = 'Review';
export const SOCIAL_POST = 'SocialPost';
export const SOCIALIZE = 'Socialize';
export const LISTINGS = 'Visibility';
export const MENTIONS = 'Mention';
export const MEETING = 'Meeting';
export const GOOGLE_QA = 'QuestionAndAnswer';

export const DEFAULT_TASK_LIST_TYPES = [
  REVIEW,
  SOCIAL_POST,
  SOCIALIZE,
  ONBOARDING,
  GENERIC,
  CLIENT_REVIEW,
  SCHEDULE_SOCIAL_POSTS,
  MEETING,
  GOOGLE_QA,
  LISTINGS,
  MENTIONS,
];

export enum TaskStatus {
  OPEN = 'Open',
  WAITING_ON_CUSTOMER = 'Waiting on Customer',
  IN_PROGRESS = 'In Progress',
  COMPLETED = 'Completed',
}

export enum TaskType {
  CUSTOM = 'Custom',
  ONBOARDING = 'Onboarding',
  REVIEW = 'Review',
  SOCIAL_POST = 'SocialPost',
  SOCIALIZE = 'Socialize',
  LISTING = 'Visibility',
  MENTION = 'Mention',
  GOOGLE_QA = 'QuestionAndAnswer',
  MEETING = 'Meeting',
  GENERIC = 'Generic',
  PROJECT = 'Project',
  SOCIAL_CALENDAR = 'Social Calendar',
  NON_AGGREGATE = 'NonAggregate', // Special case for the task list icon, not a real task type
}
